import P5 from 'p5';

export function loadImage (p5: P5, path: string): P5.Image {
  if (path.startsWith('data:')) {
    // @ts-ignore
    p5._incrementPreload();
    const pImg = new P5.Image(1, 1);

    // Non-GIF Section
    const img: HTMLImageElement = new Image();

    img.onload = () => {
      // @ts-ignore
      pImg.width = pImg.canvas.width = img.width;
      // @ts-ignore
      pImg.height = pImg.canvas.height = img.height;

      // Draw the image into the backing canvas of the p5.Image
      // @ts-ignore
      pImg.drawingContext.drawImage(img, 0, 0);
      // @ts-ignore
      pImg.modified = true;

      // @ts-ignore
      p5._decrementPreload();
    };

    img.onerror = e => {
      // @ts-ignore
      p5._friendlyFileLoadError(0, img.src);
      console.error(e);
    };

    // Set crossOrigin in case image is served with CORS headers.
    // This will let us draw to the canvas without tainting it.
    // See https://developer.mozilla.org/en-US/docs/HTML/CORS_Enabled_Image
    // When using data-uris the file will be loaded locally
    // so we don't need to worry about crossOrigin with base64 file types.
    if (path.indexOf('data:image/') !== 0) {
      img.crossOrigin = 'Anonymous';
    }
    // start loading the image
    img.src = path;
    return pImg;
  }

  return p5.loadImage(path);
}